import React, { useEffect, useState } from 'react'
import { Button, InputGroup, } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { createContent, getAllContent } from '../../services/contentService/contentService';
import Modal from 'react-bootstrap/Modal';
import "./content.scss"
import { useNavigate } from 'react-router-dom';


export default function Content() {
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [contentData, setContentData] = useState([])
    const [Images, setImages] = useState('')
    const [titleError, setTitleError] = useState(false)
    const [descriError, setDescriError] = useState(false)
    const [ForId, setForId] = useState('')
    const [show, setShow] = useState(false);
    const [picUrl, setPicUrl] = useState("")
    
    const handleClose = () => setShow(false)
    const handleShow = () => setShow(true)
    // const [fetchHandle, setFetchHandle] = useState(false)
    useEffect(() => {
        FETCHDATA()
    }, [])

    const navigate = useNavigate();

    const createContentFunc = async (picture) => {
        console.log("create content func 1")
        if(!title){
            setTitleError(true)
            return 
        }
        if(!description){
            setDescriError(true)
            return
        }
        let result = await fetch('https://roadmap-backend.herokuapp.com/api/content/data', {
            method: "post",
            headers: {
                "Content-type": "application/json",
            },
            body: JSON.stringify({ title, description,picture })
        });
        const result1 = await result.json();
        console.log('result', result1)
        setTitle('')
        setDescription('')
        
       
        navigate("/ContentPostPage");
                                           
    }
    const FETCHDATA = async () => {
        let result = await fetch("https://roadmap-backend.herokuapp.com/api/content/data", {
            method: "get",
            headers: {
                "content-type": "application/json",
            },
        })
        const result2 = await result.json()
        setContentData(result2)

    }
    
    const EditForPost = async () => {
        let _id = ForId._id
        let result = await fetch(`https://roadmap-backend.herokuapp.com/api/content/data/${_id}`, {
            method: "put",
            body: JSON.stringify({ title, description }),
            headers: {
                "content-type": "application/json"
            }
        })
        const result3 = await result.json()
        setTitle('')
        setDescription('')
        handleClose()
    }
    
    const SubmitImage=()=>{
        console.log("image submit")
       
        let data = new FormData()
        data.append("file" , Images)
        data.append("upload_preset" , "RoadmapUploading")
        data.append("cloud_name" , "roadmapcloud")
        fetch ("https://api.cloudinary.com/v1_1/roadmapcloud/image/upload",{
            method: "post",
            body: data
        })
        .then((res)=>res.json())
        .then((data)=>{
            console.log(data);
            setPicUrl(data?.url)
            createContentFunc(data?.url)

        }).catch((error)=>{
            console.log(error)
        })
    }

    return (
        <div>
            <ToastContainer />
            <div className="ForAllContainerDiv cardinfo">
                <div className="TitleDescInputFeildDiv cardinfo-box">
                    <div className="cardinfo-box-title p-0 m-0" style={{ lineHeight: 0 }}>
                        <p style={{color:"black"}}>Title</p>
                    </div>
                    <input
                        type="text"
                        value={title}
                        placeholder={"Your Title"}
                        className="p-2 Titleclssdiv"
                        onChange={(event) => {setTitle(event.target.value);setTitleError(false)}}
                        autoFocus
                        style={{border: titleError ? 'red solid 2px' : 'none'}}
                    />

                    <div className="cardinfo-box-title p-0 mt-0" style={{ lineHeight: 0 }}>
                        {/* <p style={{color:"black"}}>Description</p> */}
                    </div>
                    <textarea className='DescriptionDivStyleDiv p-1' onChange={(event) => {setDescription(event.target.value);setDescriError(false)}}
                    style={{border: descriError ? 'red solid 2px' : 'none'}}
                        placeholder={"Your Description"} value={description} />
                     <div>
                        <input style={{color:"black"}} type="file" onChange={(e)=>setImages(e.target.files[0])}/>
                        {/* <button onClick={SubmitImage}>Upload ImageFile</button> */}
                     </div>
                </div>
                    <Modal  show={show} onHide={handleClose}>
                        <Modal.Header closeButton>

                        </Modal.Header>

                        <Modal.Footer>
                            <input type="text" id="fname" name="firstname" placeholder="Your Title" style={{ width: '15rem', height: '2rem' }}
                                value={title}
                                onChange={(e) => setTitle(e.target.value)} />
                            <input type="text" id="fname" name="firstname" placeholder="Your Description." style={{ width: '15rem', height: '2rem',marginLeft:'100px' }}
                                value={description}
                                onChange={(e) => setDescription(e.target.value)} />

                            <button className='btnstylestyless' onClick={EditForPost} style={{ width: '8rem', height: '2rem' }} >Post Content</button>

                        </Modal.Footer>
                    </Modal>
                <Button title='Post Contnet' onClick={()=>{Images ? SubmitImage() : createContentFunc()}}
                    className="PostConDiv " >Post Content</Button>
                    
            </div>
            
        </div>
    )
}
